export const ALERT_TIMER = 3000
